exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group.required .control-label:after,.required-field-indicator{font-family:\"FontAwesome\";font-weight:normal;font-size:10px;content:\"\\F069\";vertical-align:super;margin-left:3px;color:#a94442}", ""]);

// exports
